import { LocalizedTextTag } from '@mews-commander/ui';
import { IconName } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { getCurrentEnterpriseCountryCode } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { useCommanderSelector } from '@mews-commander/utils';
import { createListItemWithLink } from '../helpers';
import { CapitalLaunchEnterpriseCountryCodes } from '../../financialServicesCapital/types';

const NEW_COUNTRIES_CODES = [
    CapitalLaunchEnterpriseCountryCodes.US,
    CapitalLaunchEnterpriseCountryCodes.IE,
    CapitalLaunchEnterpriseCountryCodes.PL,
];

export const CapitalMenu = () => {
    const enterpriseCountryCode: CapitalLaunchEnterpriseCountryCodes = useCommanderSelector(
        getCurrentEnterpriseCountryCode
    );
    const label = NEW_COUNTRIES_CODES.includes(enterpriseCountryCode) ? (
        <LocalizedTextTag variant="primary" textKey={TextKey.New} />
    ) : undefined;

    return createListItemWithLink({
        textKey: TextKey.Capital,
        iconName: IconName.CashPayment,
        path: 'Capital',
        isMainItem: true,
        label,
    });
};
